var map = {
	"./BUS/deviceOffline.svg": "ea00",
	"./BUS/end.svg": "5ef5",
	"./BUS/ignitionOff.svg": "8b00",
	"./BUS/moving.svg": "cf9e",
	"./BUS/overSpeed.svg": "a3b5",
	"./BUS/pto.svg": "6af0",
	"./BUS/start.svg": "f7c5",
	"./BUS/stop.svg": "905f",
	"./BUS/sweep.svg": "0eb0",
	"./BUS/unknown.svg": "2e8b",
	"./COMPACTOR/deviceOffline.svg": "a72b",
	"./COMPACTOR/end.svg": "8f02",
	"./COMPACTOR/ignitionOff.svg": "f972",
	"./COMPACTOR/moving.svg": "70e0",
	"./COMPACTOR/overSpeed.svg": "cb21",
	"./COMPACTOR/pto.svg": "6bb2",
	"./COMPACTOR/start.svg": "ad6f",
	"./COMPACTOR/stop.svg": "2f0d",
	"./COMPACTOR/sweep.svg": "21c1",
	"./COMPACTOR/unknown.svg": "5014",
	"./COMPRESSOR/deviceOffline.svg": "d4cf",
	"./COMPRESSOR/end.svg": "46cd",
	"./COMPRESSOR/ignitionOff.svg": "d1e2",
	"./COMPRESSOR/moving.svg": "d946",
	"./COMPRESSOR/overSpeed.svg": "e753",
	"./COMPRESSOR/pto.svg": "9cef",
	"./COMPRESSOR/start.svg": "f5b5",
	"./COMPRESSOR/stop.svg": "cf04",
	"./COMPRESSOR/sweep.svg": "ac74",
	"./COMPRESSOR/unknown.svg": "94ee",
	"./CONTAINER_WASHING_TRUCK/deviceOffline.svg": "751d",
	"./CONTAINER_WASHING_TRUCK/end.svg": "0047",
	"./CONTAINER_WASHING_TRUCK/ignitionOff.svg": "8394",
	"./CONTAINER_WASHING_TRUCK/moving.svg": "5edd",
	"./CONTAINER_WASHING_TRUCK/overSpeed.svg": "4ac1",
	"./CONTAINER_WASHING_TRUCK/pto.svg": "e8ac",
	"./CONTAINER_WASHING_TRUCK/start.svg": "1e9a",
	"./CONTAINER_WASHING_TRUCK/stop.svg": "bd56",
	"./CONTAINER_WASHING_TRUCK/sweep.svg": "d6c6",
	"./CONTAINER_WASHING_TRUCK/unknown.svg": "8875",
	"./CRANE/deviceOffline.svg": "5efb",
	"./CRANE/end.svg": "3cee",
	"./CRANE/ignitionOff.svg": "10b7",
	"./CRANE/moving.svg": "d03d",
	"./CRANE/overSpeed.svg": "104a",
	"./CRANE/pto.svg": "23ba",
	"./CRANE/start.svg": "8eba",
	"./CRANE/stop.svg": "e83b",
	"./CRANE/sweep.svg": "6eea",
	"./CRANE/unknown.svg": "9ea9",
	"./DEIANA/deviceOffline.svg": "6b28",
	"./DEIANA/end.svg": "a460",
	"./DEIANA/ignitionOff.svg": "cc53",
	"./DEIANA/moving.svg": "c457",
	"./DEIANA/overSpeed.svg": "b429",
	"./DEIANA/pto.svg": "1a70",
	"./DEIANA/start.svg": "c382",
	"./DEIANA/stop.svg": "ef10",
	"./DEIANA/sweep.svg": "a866",
	"./DEIANA/unknown.svg": "94e2",
	"./DOUBLE_PICKUP_CABIN/deviceOffline.svg": "7b90",
	"./DOUBLE_PICKUP_CABIN/end.svg": "73ff",
	"./DOUBLE_PICKUP_CABIN/ignitionOff.svg": "d040",
	"./DOUBLE_PICKUP_CABIN/moving.svg": "35be",
	"./DOUBLE_PICKUP_CABIN/overSpeed.svg": "a848",
	"./DOUBLE_PICKUP_CABIN/pto.svg": "918a",
	"./DOUBLE_PICKUP_CABIN/start.svg": "abbb",
	"./DOUBLE_PICKUP_CABIN/stop.svg": "caea",
	"./DOUBLE_PICKUP_CABIN/sweep.svg": "b498",
	"./DOUBLE_PICKUP_CABIN/unknown.svg": "fdd4",
	"./ONE_EIGHT/deviceOffline.svg": "f0f9",
	"./ONE_EIGHT/end.svg": "d21b",
	"./ONE_EIGHT/ignitionOff.svg": "20df",
	"./ONE_EIGHT/moving.svg": "0e33",
	"./ONE_EIGHT/overSpeed.svg": "56d3",
	"./ONE_EIGHT/pto.svg": "4164",
	"./ONE_EIGHT/start.svg": "8027",
	"./ONE_EIGHT/stop.svg": "4822",
	"./ONE_EIGHT/sweep.svg": "5c03",
	"./ONE_EIGHT/unknown.svg": "b849",
	"./PERSONAL/ignitionOff.svg": "cf63",
	"./PERSONAL/moving.svg": "a467",
	"./PERSONAL/stop.svg": "a972",
	"./REFRIGERATOR/deviceOffline.svg": "e29d",
	"./REFRIGERATOR/ignitionOff.svg": "1fd4",
	"./REFRIGERATOR/moving.svg": "bce5",
	"./REFRIGERATOR/overSpeed.svg": "cc95",
	"./REFRIGERATOR/pto.svg": "eb6c",
	"./REFRIGERATOR/stop.svg": "9194",
	"./REFRIGERATOR/sweep.svg": "f5ec",
	"./SHOVEL/deviceOffline.svg": "8869",
	"./SHOVEL/end.svg": "469a",
	"./SHOVEL/ignitionOff.svg": "d3d5",
	"./SHOVEL/moving.svg": "927a",
	"./SHOVEL/overSpeed.svg": "2a7c",
	"./SHOVEL/pto.svg": "5320",
	"./SHOVEL/start.svg": "6998",
	"./SHOVEL/stop.svg": "b23c",
	"./SHOVEL/sweep.svg": "89f2",
	"./SHOVEL/unknown.svg": "9c31",
	"./SINGLE_PICKUP_CABIN/deviceOffline.svg": "65e9",
	"./SINGLE_PICKUP_CABIN/end.svg": "8fe9",
	"./SINGLE_PICKUP_CABIN/ignitionOff.svg": "f250",
	"./SINGLE_PICKUP_CABIN/moving.svg": "8fb0",
	"./SINGLE_PICKUP_CABIN/overSpeed.svg": "3363",
	"./SINGLE_PICKUP_CABIN/pto.svg": "a3f7",
	"./SINGLE_PICKUP_CABIN/start.svg": "6d9d",
	"./SINGLE_PICKUP_CABIN/stop.svg": "c04d",
	"./SINGLE_PICKUP_CABIN/sweep.svg": "f591",
	"./SINGLE_PICKUP_CABIN/unknown.svg": "be11",
	"./SUV/deviceOffline.svg": "3ea6",
	"./SUV/end.svg": "5198",
	"./SUV/ignitionOff.svg": "c1f2",
	"./SUV/moving.svg": "f8e3",
	"./SUV/overSpeed.svg": "46cc",
	"./SUV/pto.svg": "a7b5",
	"./SUV/start.svg": "b414",
	"./SUV/stop.svg": "fd48",
	"./SUV/sweep.svg": "a61b",
	"./SUV/unknown.svg": "bcfc",
	"./SWEEPER/deviceOffline.svg": "c811",
	"./SWEEPER/end.svg": "af35",
	"./SWEEPER/ignitionOff.svg": "5ab3",
	"./SWEEPER/moving.svg": "8228",
	"./SWEEPER/overSpeed.svg": "005d",
	"./SWEEPER/pto.svg": "30ab",
	"./SWEEPER/start.svg": "3188",
	"./SWEEPER/stop.svg": "f740",
	"./SWEEPER/sweep.svg": "e91e",
	"./SWEEPER/unknown.svg": "07a8",
	"./TANKER/deviceOffline.svg": "731a",
	"./TANKER/end.svg": "ce41",
	"./TANKER/ignitionOff.svg": "77e8",
	"./TANKER/moving.svg": "518d",
	"./TANKER/overSpeed.svg": "ceb0",
	"./TANKER/pto.svg": "bec0",
	"./TANKER/start.svg": "9351",
	"./TANKER/stop.svg": "4c30",
	"./TANKER/sweep.svg": "28e5",
	"./TANKER/unknown.svg": "29f3",
	"./TIPPER/deviceOffline.svg": "6659",
	"./TIPPER/end.svg": "877c",
	"./TIPPER/ignitionOff.svg": "9cbc",
	"./TIPPER/moving.svg": "51c1",
	"./TIPPER/overSpeed.svg": "66b9",
	"./TIPPER/pto.svg": "25d6",
	"./TIPPER/start.svg": "4499",
	"./TIPPER/stop.svg": "2f2b",
	"./TIPPER/sweep.svg": "e8ea",
	"./TIPPER/unknown.svg": "9ba4",
	"./WHITE_WATER/deviceOffline.svg": "f954",
	"./WHITE_WATER/end.svg": "e2f3",
	"./WHITE_WATER/ignitionOff.svg": "724b",
	"./WHITE_WATER/moving.svg": "322c",
	"./WHITE_WATER/overSpeed.svg": "5349",
	"./WHITE_WATER/pto.svg": "8492",
	"./WHITE_WATER/start.svg": "771e",
	"./WHITE_WATER/stop.svg": "026e",
	"./WHITE_WATER/sweep.svg": "4c56",
	"./WHITE_WATER/unknown.svg": "79e0",
	"./WINCH/deviceOffline.svg": "2b6c",
	"./WINCH/end.svg": "6f3e",
	"./WINCH/ignitionOff.svg": "837a",
	"./WINCH/moving.svg": "805d",
	"./WINCH/overSpeed.svg": "dbe8",
	"./WINCH/pto.svg": "97bf",
	"./WINCH/start.svg": "06bb",
	"./WINCH/stop.svg": "d7f4",
	"./WINCH/sweep.svg": "bae8",
	"./WINCH/unknown.svg": "abd5",
	"./WORKSHOP_CAR/deviceOffline.svg": "ef0d",
	"./WORKSHOP_CAR/end.svg": "7d6d",
	"./WORKSHOP_CAR/ignitionOff.svg": "ee77",
	"./WORKSHOP_CAR/moving.svg": "6187",
	"./WORKSHOP_CAR/overSpeed.svg": "a389",
	"./WORKSHOP_CAR/pto.svg": "efa3",
	"./WORKSHOP_CAR/start.svg": "4a68",
	"./WORKSHOP_CAR/stop.svg": "0c7d",
	"./WORKSHOP_CAR/sweep.svg": "3b0c",
	"./WORKSHOP_CAR/unknown.svg": "689e",
	"./cat_svg/1551754729.svg": "d774",
	"./cat_svg/ad8d6a04dd7dae79177a4a1e136568de(1).svg": "af91",
	"./cat_svg/bulk-truck-icon.svg": "1d65",
	"./cat_svg/crane-truck-icon.svg": "9fe5",
	"./cat_svg/forklift-truck-icon.svg": "6323",
	"./cat_svg/green-steps.svg": "838b",
	"./cat_svg/icon-tool-truck.svg": "2c9b",
	"./cat_svg/mining-truck-icon.svg": "1181",
	"./cat_svg/squatmarkercrimson.svg": "2e7e",
	"./cat_svg/tiger-footprint.svg": "5355",
	"./cat_svg/towing-truck-icon.svg": "e6c2",
	"./cat_svg/trash-truck-icon.svg": "8cc7",
	"./cat_svg/water-truck-icon.svg": "f237",
	"./deviceOffline.svg": "30d8",
	"./end.svg": "9e2b",
	"./geofnce_events/geofenceEnter.svg": "89cf",
	"./geofnce_events/geofenceExit.svg": "1cfb",
	"./idle.svg": "2a8e",
	"./ignitionOff.svg": "b261",
	"./moving.svg": "4b99",
	"./offline.svg": "2d3a",
	"./overSpeed.svg": "3f88",
	"./pto.svg": "bc1d",
	"./start.svg": "8bde",
	"./stop.svg": "f739",
	"./stopped.svg": "7529",
	"./sweep.svg": "2306",
	"./unknown.svg": "3699",
	"./washing.svg": "92bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ded";